import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface ProductChildrenResponse {
  children: any[];
}

interface ProductAttributesResponse {
  attributes: any[];
}

@Injectable()
export class ProductWidgetService {
  constructor(private http: HttpClient) {
    console.log('[Widget] ProductWidgetService instantiated');
  }

  private get baseUrl(): string {
    return `${environment.apiBaseUrl}/api`;
  }

  private getStoreId() {
    const selected = localStorage.getItem('ss_SelectedStoreId');
    if (selected) {
      return Number(selected);
    }

    const storeRaw = localStorage.getItem('store');
    if (storeRaw) {
      try {
        const parsed = JSON.parse(storeRaw);
        if (parsed?.SelectedStoreId) {
          return Number(parsed.SelectedStoreId);
        }
      } catch {
        // ignore parse error
      }
    }

    return ;
  }

  private buildHeaders(extra: Record<string, string> = {}): HttpHeaders {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
      'X-Full-Referer': window.location.href,
      ...extra
    };

    const token = localStorage.getItem('access_token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return new HttpHeaders(headers);
  }

  private withNoCache(url: string): string {
    const delimiter = url.includes('?') ? '&' : '?';
    return `${url}${delimiter}nocache=${Date.now()}`;
  }

  //////////////////
  getDetailProduct(id: string): Observable<{ product: any }> {
    let selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    let store_id: number | undefined;

    if (!selectedStoreId) {
      const store = localStorage.getItem('store');
      if (store) {
        try {
          const parsedStore = JSON.parse(store);
          selectedStoreId = parsedStore?.SelectedStoreId || '';
        } catch (error) {
          console.error('Erro ao parsear store do localStorage:', error);
        }
      }
    }

    if (selectedStoreId) {
      store_id = Number(selectedStoreId);
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/public/admin/store/${store_id}/app_product/${id}`;
    url = this.getNoCacheUrl(url);

    // ✅ rota pública: não usar authHeaderService (evita Authorization/withCredentials)
    const headers = new HttpHeaders({
      'X-Full-Referer': window.location.href,
    });

    return this.http
      .get<{ product: any }>(url, {
        headers,
        withCredentials: false, // ✅ garante que não vai cookie
      })
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar detalhes do produto:', error);
          return throwError(() => error);
        })
      );
  }
  private getNoCacheUrl(url: string): string {
    const timestamp = new Date().getTime(); // 🔥 Garante uma URL única
    return `${url}${url.includes('?') ? '&' : '?'}nocache=${timestamp}`;
  }
  //////////////////

  getChildremProducts(id: string): Observable<{ children: any[] }> {
    let selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    let store_id: number | undefined;

    if (!selectedStoreId) {
      const store = localStorage.getItem('store');
      if (store) {
        try {
          const parsedStore = JSON.parse(store);
          selectedStoreId = parsedStore?.SelectedStoreId || '';
        } catch (error) {
          console.error('Erro ao parsear store do localStorage:', error);
        }
      }
    }

    if (selectedStoreId) {
      store_id = Number(selectedStoreId);
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/public/admin/store/${store_id}/app_product/${id}/children`;
    url = this.getNoCacheUrl(url);

    const headers = new HttpHeaders({
      'X-Full-Referer': window.location.href,
    });

    return this.http
      .get<{ children: any[] }>(url, { headers, withCredentials: false })
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar produtos filhos:', error);
          return throwError(() => error);
        })
      );
  }

  getChildremProductsAttributes(id: string): Observable<{ attributes: any[] }> {
    let selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    let store_id: number | undefined;

    if (!selectedStoreId) {
      const store = localStorage.getItem('store');
      if (store) {
        try {
          const parsedStore = JSON.parse(store);
          selectedStoreId = parsedStore?.SelectedStoreId || '';
        } catch (error) {
          console.error('Erro ao parsear store do localStorage:', error);
        }
      }
    }

    if (selectedStoreId) {
      store_id = Number(selectedStoreId);
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/public/admin/store/${store_id}/app_product/${id}/children/attributes`;
    url = this.getNoCacheUrl(url);

    const headers = new HttpHeaders({
      'X-Full-Referer': window.location.href,
    });

    return this.http
      .get<{ attributes: any[] }>(url, { headers, withCredentials: false })
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar atributos dos produtos filhos:', error);
          return throwError(() => error);
        })
      );
  }
}
